import { useState, useRef } from 'react';
import styled from '@emotion/styled';
import Icon from 'components/Kizen/Icon';
import IconButton from 'components/Kizen/IconButton';
import { ICON_BUTTON_SIZING } from 'components/Kizen/IconButton';
import { colorsButton } from 'app/colors';
import MobileActivitySelector from 'pages/Common/MobileActivitySelector';
import MobileAutomationSelector from 'pages/Common/MobileAutomationSelector';

const IconBar = styled.div`
  flex: 1;
  display: flex;
  justify-content: ${({ condensed }) => (condensed ? 'flex-end' : 'center')};
  position: relative;

  /* Handle the StagedSelect wrapped in a div to style the menu header/footer */
  > a,
  > div > a,
  > button,
  > div > button {
    transition: box-shadow 0.5s ease-in-out;
    transition: padding 0.5s ease-in-out;
    transition: border-color 0.5s ease-in-out;
    padding: ${({ condensed }) => (condensed ? `0 10px` : `0 15`)};

    > i {
      transition-property: opacity;
      transition-duration: 0.5s;
      transition-timing-function: ease-in-out;
    }

    &:hover i {
      color: var(--color-background-darker);
    }
  }

  &.is-scrolled {
    > a,
    div > a,
    > button,
    > div > button {
      cursor: default;
      border-color: transparent;
      box-shadow: none;
      > i {
        opacity: 0 !important;
      }
    }
  }
`;

const StyledIconButton = styled(IconButton)`
  margin-left: 10px;
  margin-right: 10px;
`;

const ActionBar = ({
  condensed = false,
  hasEditAccess,
  customObjectId,
  scrolled,
  onStartAutomation,
  canStartAutomations,
  onClickEmail,
  onClickPhone,
}) => {
  const [showLogActivity, setShowLogActivity] = useState(false);
  const actionButtonRef = useRef(null);

  const [showSelectedAutomation, setShowSelectedAutomation] = useState();
  const automationButtonRef = useRef(null);

  return (
    <>
      <IconBar
        className={scrolled ? 'is-scrolled' : ''}
        condensed={condensed}
        scrolled={scrolled}
      >
        {/* phone */}
        <StyledIconButton
          sizing={ICON_BUTTON_SIZING.overlay}
          color={colorsButton.iconGray}
          borderColor="var(--color-border-medium)"
          disabled={scrolled}
          onClick={onClickPhone}
        >
          <Icon icon="phone" />
        </StyledIconButton>
        {/* email */}
        <StyledIconButton
          sizing={ICON_BUTTON_SIZING.overlay}
          color={colorsButton.iconGray}
          borderColor="var(--color-border-medium)"
          disabled={scrolled}
          onClick={onClickEmail}
        >
          <Icon icon="email" />
        </StyledIconButton>
        {/* log activity */}
        <StyledIconButton
          sizing={ICON_BUTTON_SIZING.overlay}
          color={colorsButton.iconGray}
          borderColor="var(--color-border-medium)"
          disabled={scrolled}
          onClick={() => setShowLogActivity(true)}
          ref={actionButtonRef}
        >
          <Icon icon="clipboard-check" />
        </StyledIconButton>
        <MobileActivitySelector
          showLogActivity={showLogActivity}
          target={actionButtonRef.current}
          customObjectId={customObjectId}
          onSetVisible={(val) => setShowLogActivity(val)}
          scrolled={scrolled}
          shownScrolled={false}
        />
        {/* automation */}
        {canStartAutomations && hasEditAccess ? (
          <StyledIconButton
            sizing={ICON_BUTTON_SIZING.overlay}
            color={colorsButton.iconGray}
            borderColor="var(--color-border-medium)"
            disabled={scrolled}
            onClick={() => setShowSelectedAutomation(true)}
            ref={automationButtonRef}
          >
            <Icon icon="play" />
          </StyledIconButton>
        ) : null}

        <MobileAutomationSelector
          showSelectedAutomation={showSelectedAutomation}
          target={automationButtonRef.current}
          onSetVisible={(val) => setShowSelectedAutomation(val)}
          scrolled={scrolled}
          shownScrolled={false}
          customObjectId={customObjectId}
          onStartAutomation={onStartAutomation}
        />
      </IconBar>
    </>
  );
};

export default ActionBar;
